<template>

    <div data-app="true">
        <v-dialog
            dense
            v-model="dialogModel"
            max-width="500"
        >
            <toolbar-page title="Assign roles" icon="mdi-security">
                <template slot="buttons">
                    <v-tooltip color="primary" top>
                        <template v-slot:activator="{ on }">
                            <v-btn
                                id="closeButton"
                                @click="closeDialog"
                                v-on="on"
                                icon
                            >
                                <v-icon>mdi-close</v-icon>
                            </v-btn>
                        </template>
                        <span>Close this dialog</span>
                    </v-tooltip>
                </template>

            </toolbar-page>

            <v-list id="rolesList" two-line subheade>
                <v-subheader>Switch on the roles you want to assign to this user</v-subheader>

                <v-list-item v-for="(availableRole, index) in availableRoles" :key="availableRole.id">

                    <v-list-item-action avatar>

                        <v-switch
                            :disabled="!hasPermission('update roles')"
                            ref="switch"
                            v-model="checkboxState"
                            :color="hasPermission('update roles') ? 'primary' : 'grey darken-2'"
                            required
                            :hide-details="false"
                            :value="availableRole.name"
                            @click.native="saveState()"
                        >
                        </v-switch>

                    </v-list-item-action>

                    <v-list-item-content class="pt-0 pb-0">
                        <v-list-item-title>{{ ucFirst(availableRole.name) }}</v-list-item-title>
                        <v-list-item-subtitle>

                            <span>Contains {{ availableRole.permissions.length }} permissions</span>

                        </v-list-item-subtitle>
                    </v-list-item-content>

                    <v-list-item-action>
                        <dangerous-permissions-icon :permissions="availableRole.permissions"/>
                    </v-list-item-action>

                    <v-list-item-action>
                        <v-btn icon @click="viewPermissionsClicked(availableRole.permissions)">
                            <v-icon>mdi-eye</v-icon>
                        </v-btn>
                    </v-list-item-action>

                </v-list-item>

            </v-list>

            <!-- VIEW PERMISSIONS DIALOG -->
            <view-permissions-dialog v-model="permissionDialogModel"
                                     :items="permissions"
            ></view-permissions-dialog>

        </v-dialog>

    </div>
</template>

<script>

import ToolbarPage from '../../../../components/UI/ToolbarPage';
import ViewPermissionsDialog from "../ViewPermissionsDialog";
import {dangerousPermissionsMixin} from "../../../../components/mixins/dangerousPermissionsMixin";
import DangerousPermissionsIcon from "../DangerousPermissionsIcon";

export default {

    mixins: [dangerousPermissionsMixin],

    components: {
        DangerousPermissionsIcon,
        ToolbarPage,
        ViewPermissionsDialog
    },

    props: {
        value: {
            type: Boolean,
            required: true,
        },
        roles: {
            type: Array,
            required: false
        },
        availableRoles: {
            type: Array,
            required: false,
        },
    },

    data() {
        return {
            checkboxState: [],
            permissions: [],
            permissionDialogModel: false,
        }
    },

    computed: {
        dialogModel: {
            get() {
                return this.value;
            },
            set() {
                this.closeDialog();
            }
        }
    },

    watch: {
        roles: {
            immediate: true,
            handler(newValue) {
                this.checkboxState = newValue;
            }
        }
    },

    methods: {

        saveState() {
            this.$emit('roles-changed', this.checkboxState);
        },

        closeDialog() {
            this.$emit('input', false);
        },

        viewPermissionsClicked(permissions) {
            this.permissionDialogModel = true;
            this.permissions = permissions;
        }
    }
}

</script>
